import { Injectable } from '@angular/core'
import { GbApiService } from 'libs/shared/data-access-core/src/lib/+state/gb-api.service'
import { Observable } from 'rxjs'
import { MenuItemsEntity } from './menu-items.models'

@Injectable({
  providedIn: 'root',
})
export class MenuItemsApiService extends GbApiService {
  getMenuItems(urlName: string): Observable<MenuItemsEntity[]> {
    const url = `auctions/${urlName}/menu-items/`
    return this.get<MenuItemsEntity[]>(url)
  }

  createMenuItem(menuItem: MenuItemsEntity): Observable<MenuItemsEntity> {
    const url = `auctions/${menuItem.auction}/menu-items/`
    return this.post<MenuItemsEntity>(url, menuItem)
  }

  updateMenuItem(menuItem: MenuItemsEntity): Observable<MenuItemsEntity> {
    const url = `auctions/${menuItem.auction}/menu-items/${menuItem.uuid}/`
    return this.patch<MenuItemsEntity>(url, menuItem)
  }

  deleteMenuItem(urlName: string, uuid: string): Observable<void> {
    const url = `auctions/${urlName}/menu-items/${uuid}/`
    return this.delete<void>(url)
  }

  reorderMenuItems(urlName: string, menuItems: Partial<MenuItemsEntity>[]) {
    const url = `auctions/${urlName}/menu-items/reorder/`
    return this.post<void>(url, { menu_items: menuItems, auction: urlName })
  }
}
